'use strict';

const libPictView = require('pict-view');

const CSS_HASH = 'CustomerConfigScreen';

const CSS = /*css*/`
	.ccs-wrap { padding: 1.25rem 1.5rem 2rem; }
	.ccs-head { margin: 0 0 1rem; }
	.ccs-title { font-size:1.5rem; font-weight:700; line-height:1.2; margin:0; color:var(--theme-color-text-primary,#1f2733); }
	.ccs-subtitle { font-size:0.9rem; color:var(--theme-color-text-muted,#6b7686); margin:0.2rem 0 0; max-width:52rem; }
	.ccs-main { border:1px solid var(--theme-color-border-default,#d7dce3); border-radius:8px; background:var(--theme-color-background-panel,#fff); padding:1.1rem 1.25rem; min-height:18rem; max-width:58rem; }
	.ccs-empty { display:flex; align-items:center; justify-content:center; text-align:center; min-height:12rem; color:var(--theme-color-text-muted,#6b7686); gap:0.5rem; }
	.ccs-field { margin:0 0 0.9rem; }
	.ccs-label { display:block; font-size:0.66rem; font-weight:700; text-transform:uppercase; letter-spacing:0.05em; color:var(--theme-color-text-muted,#6b7686); margin:0 0 0.35rem; }
	.ccs-customer { font-size:0.98rem; font-weight:600; color:var(--theme-color-text-primary,#1f2733); }
	.ccs-select, .ccs-input { font-size:0.88rem; padding:0.4rem 0.55rem; border:1px solid var(--theme-color-border-medium,#d5dbe3); border-radius:6px; background:var(--theme-color-background-input,#fff); color:var(--theme-color-text-primary,#1f2733); box-sizing:border-box; max-width:100%; }
	.ccs-select { min-width:16rem; }
	.ccs-input { width:100%; max-width:28rem; }
	.ccs-section { border-top:1px solid var(--theme-color-border-light,#eef1f6); padding-top:1rem; margin-top:1rem; }
	.ccs-section:first-of-type { border-top:none; padding-top:0; margin-top:0; }
	.ccs-section-title { font-size:1.05rem; font-weight:700; margin:0 0 0.3rem; color:var(--theme-color-text-primary,#1f2733); }
	.ccs-help { font-size:0.84rem; color:var(--theme-color-text-muted,#6b7686); margin:0 0 0.8rem; }
	.ccs-note { font-size:0.84rem; color:var(--theme-color-text-secondary,#45505f); background:var(--theme-color-background-secondary,#f7f9fb); border-radius:7px; padding:0.6rem 0.75rem; margin:0 0 1rem; }
	.ccs-warn { color:var(--theme-color-status-warning,#b7791f); }
	.ccs-check { display:flex; gap:0.5rem; align-items:flex-start; font-size:0.9rem; color:var(--theme-color-text-primary,#1f2733); margin:0 0 0.5rem; cursor:pointer; }
	.ccs-check input { margin-top:0.2rem; }
	.ccs-checks { display:flex; flex-wrap:wrap; gap:0.3rem 1.1rem; margin:0 0 0.8rem; }
	.ccs-checks .ccs-check { margin:0; }
	.ccs-table { width:100%; border-collapse:collapse; font-size:0.88rem; margin:0 0 0.8rem; }
	.ccs-table th { text-align:left; font-size:0.7rem; font-weight:700; text-transform:uppercase; letter-spacing:0.04em; color:var(--theme-color-text-muted,#6b7686); padding:0.35rem 0.5rem; border-bottom:1px solid var(--theme-color-border-default,#d7dce3); }
	.ccs-table td { padding:0.45rem 0.5rem; border-bottom:1px solid var(--theme-color-border-light,#eef1f6); vertical-align:top; color:var(--theme-color-text-primary,#1f2733); }
	.ccs-table tr.is-selected td { background:var(--theme-color-background-selected,#f5f5fe); }
	.ccs-sub { display:block; font-size:0.74rem; color:var(--theme-color-text-muted,#6b7686); }
	.ccs-chips { display:flex; flex-wrap:wrap; gap:0.3rem; align-items:center; }
	.ccs-chip { display:inline-flex; align-items:center; gap:0.25rem; font-size:0.8rem; color:var(--theme-color-text-primary,#1f2733); }
	.ccs-chip { background:var(--theme-color-background-selected,#eef0fe); border:1px solid var(--theme-color-border-medium,#d5dbe3); border-radius:999px; padding:0.08rem 0.2rem 0.08rem 0.6rem; }
	.ccs-chip.is-unknown { border-style:dashed; color:var(--theme-color-status-warning,#b7791f); }
	.ccs-chip-x { border:none; background:transparent; color:var(--theme-color-text-muted,#6b7686); cursor:pointer; font-size:0.95rem; line-height:1; padding:0 0.3rem; }
	.ccs-btn { font-size:0.82rem; font-weight:600; padding:0.32rem 0.7rem; border-radius:6px; border:1px solid var(--theme-color-border-medium,#d5dbe3); background:var(--theme-color-background-panel,#fff); color:var(--theme-color-text-secondary,#45505f); cursor:pointer; white-space:nowrap; }
	.ccs-btn[disabled] { opacity:0.5; cursor:default; }
	.ccs-btn.is-danger:hover { color:var(--theme-color-status-danger,#c0392b); border-color:var(--theme-color-status-danger,#c0392b); }
	.ccs-row { display:flex; gap:0.5rem; align-items:center; flex-wrap:wrap; margin:0 0 0.8rem; }
	.ccs-picker { position:relative; display:inline-flex; flex-direction:column; min-width:16rem; max-width:28rem; }
	.ccs-suggest { display:flex; flex-direction:column; }
	.ccs-suggest:empty { display:none; }
	.ccs-suggestion { text-align:left; font-size:0.85rem; padding:0.35rem 0.6rem; border:1px solid var(--theme-color-border-light,#e6eaf0); border-top:none; background:var(--theme-color-background-panel,#fff); color:var(--theme-color-text-primary,#1f2733); cursor:pointer; }
	.ccs-suggestion:hover, .ccs-suggestion:focus { background:var(--theme-color-background-selected,#f5f5fe); }
	.ccs-more { font-size:0.78rem; color:var(--theme-color-text-muted,#6b7686); padding:0.3rem 0.6rem; }
	.ccs-savebar { margin:1.1rem 0 0.2rem; display:flex; gap:0.8rem; align-items:center; }
	.ccs-save { font-size:0.9rem; font-weight:600; padding:0.5rem 1.2rem; border-radius:7px; border:1px solid var(--theme-color-brand-primary,#5650e6); background:var(--theme-color-brand-primary,#5650e6); color:#fff; cursor:pointer; }
	.ccs-save[disabled] { opacity:0.6; cursor:default; }
	.ccs-unsaved { font-size:0.82rem; color:var(--theme-color-status-warning,#b7791f); }
	.ccs-msg { font-size:0.85rem; color:var(--theme-color-status-success,#1f7a4d); background:var(--theme-color-background-tertiary,#f0f7f2); border-radius:6px; padding:0.45rem 0.7rem; margin:0 0 0.9rem; }
	.ccs-error { font-size:0.85rem; color:var(--theme-color-status-danger,#c0392b); margin:0 0 0.9rem; }
	@media (max-width: 640px)
	{
		.ccs-wrap { padding: 1rem; }
		.ccs-select, .ccs-picker { min-width:0; width:100%; }
		.ccs-table th:nth-child(3), .ccs-table td:nth-child(3) { display:none; }
	}
`;

/**
 * @typedef {Object} CustomerConfigScreenViewOptions
 * @property {string} ViewIdentifier - the view's hash, which the router renders
 * @property {string} ProviderHash - the screen's provider
 * @property {string} MountID - the id of the element the provider renders into
 * @property {string} Title
 * @property {string} Subtitle
 */

/**
 * Build the thin view shell of a customer configuration screen: a header and one mount the screen's provider fills.
 * Every such screen shares one stylesheet.
 *
 * @param {CustomerConfigScreenViewOptions} pOptions
 * @return {{ View: typeof libPictView, default_configuration: Record<string, any> }}
 */
function buildCustomerConfigScreenView(pOptions)
{
	/** The screen's view: a header and one mount its provider fills. */
	class CustomerConfigScreenView extends libPictView
	{
		/** @return {any} the screen's provider */
		get provider()
		{
			return this.pict.providers[pOptions.ProviderHash];
		}

		/**
		 * @param {any} pRenderable
		 * @return {any}
		 */
		onAfterRender(pRenderable)
		{
			this.pict.CSSMap.injectCSS();
			const tmpProvider = this.provider;
			if (tmpProvider)
			{
				tmpProvider.render();
				if (!tmpProvider.state.Loaded && !tmpProvider.state.Loading)
				{
					tmpProvider.loadAsync();
				}
			}
			return super.onAfterRender(pRenderable);
		}
	}

	const tmpTemplateHash = `${pOptions.ViewIdentifier}-Wrap`;
	const tmpEsc = (pValue) => String(pValue).replace(/[&<>"']/g, (pChar) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', '\'': '&#39;' }[pChar]));
	return {
		View: CustomerConfigScreenView,
		default_configuration:
		{
			ViewIdentifier: pOptions.ViewIdentifier,
			DefaultRenderable: tmpTemplateHash,
			DefaultDestinationAddress: '#PlatformConfiguration-Application-Container',
			AutoRender: false,
			CSSHash: CSS_HASH,
			CSS: CSS,
			Templates:
			[
				{
					Hash: tmpTemplateHash,
					Template: /*html*/`
						<div class="ccs-wrap">
							<div class="ccs-head">
								<h1 class="ccs-title">${tmpEsc(pOptions.Title)}</h1>
								<p class="ccs-subtitle">${tmpEsc(pOptions.Subtitle)}</p>
							</div>
							<div id="${pOptions.MountID}" class="ccs-main"></div>
						</div>`,
				},
			],
			Renderables:
			[
				{
					RenderableHash: tmpTemplateHash,
					TemplateHash: tmpTemplateHash,
					DestinationAddress: '#PlatformConfiguration-Application-Container',
					RenderMethod: 'replace',
				},
			],
		},
	};
}

module.exports = { buildCustomerConfigScreenView, CSS_HASH };
